import React from 'react';
import { Heart, Users, Award, TrendingUp, Clock, Shield } from 'lucide-react';

const WhyJoinUs = ({ className = "" }) => {
  const benefits = [
    {
      icon: Heart,
      title: "Purpose-Driven Work",
      description: "Make a real difference in seniors' lives every day through meaningful work"
    },
    {
      icon: Users,
      title: "Supportive Community",
      description: "Join a team that values collaboration, respect, and mutual support"
    },
    {
      icon: Award,
      title: "Growth Opportunities",
      description: "Continuous learning and career advancement in the growing senior care sector"
    },
    {
      icon: TrendingUp,
      title: "Competitive Benefits",
      description: "Comprehensive package including health insurance and retirement plans"
    },
    {
      icon: Clock,
      title: "Work-Life Balance",
      description: "Flexible scheduling and supportive environment for personal wellbeing"
    },
    {
      icon: Shield,
      title: "Job Security",
      description: "Stable career in an essential and rapidly growing industry"
    }
  ];

  return (
    <div id="why-join-us" className={`pt-16 sm:pt-20 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 px-6 py-3 rounded-full text-[var(--primarycolor)] text-sm font-medium mb-8">
            <Heart className="w-4 h-4" />
            Why Join Our Team
          </div>
          
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight">
            More Than a Job - 
            <span className="block text-[var(--primarycolor)] font-normal">A Calling</span>
          </h2>
          
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            At Dignity Retirement Village, we believe that our team members are the heart of our community. 
            We invest in your growth, value your contributions, and support your journey.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div key={index} className="group bg-white rounded-2xl p-8 border border-gray-200 hover:border-red-300 transition-all duration-300">
                <div className="w-16 h-16 bg-red-50 group-hover:bg-red-100 rounded-2xl flex items-center justify-center mb-6 transition-all duration-300">
                  <IconComponent className="w-8 h-8 text-[var(--primarycolor)]" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WhyJoinUs;